// @ts-ignore
import GLightbox from 'glightbox';

export class Lightbox {
  selector: string;
  lightboxes: any;

  constructor() {
    this.selector = 'data-lightbox';
    this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
    this.init();
  }

  init() {
    this.lightboxes.forEach((lightbox) => {
      let key = lightbox.getAttribute(this.selector);
      const glightbox = GLightbox({
        selector: '[' + this.selector + '="' + key + '"]',
        zoomable: false,
        draggable: true,
        touchNavigation: true,
        loop: false,
        closeButton: true,
      });
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new Lightbox();
});
